import React from 'react';

import './CustomerInfoForm.css';

const CustomerInfoForm = () => <div> CustomerInfoForm</div>;

export default CustomerInfoForm;
